import { getReporter } from './reporter'

/** 慢资源阈值（ms） */
const SLOW_THRESHOLD = 500
/** 大资源阈值（bytes） */
const LARGE_THRESHOLD = 512000

/**
 * 监控资源加载性能
 *
 * 使用 PerformanceObserver 监听 resource 类型，
 * 只采集慢资源（>500ms）或大资源（>500KB）
 */
export function setupResources(): void {
  if (typeof window === 'undefined' || typeof PerformanceObserver === 'undefined') return

  try {
    const observer = new PerformanceObserver(list => {
      const reporter = getReporter()
      if (!reporter) return

      for (const entry of list.getEntries()) {
        const res = entry as PerformanceResourceTiming
        const size = res.transferSize || 0
        const duration = res.duration

        if (duration <= SLOW_THRESHOLD && size <= LARGE_THRESHOLD) continue

        reporter.addResource({
          name: normalizeResourceUrl(res.name),
          type: res.initiatorType,
          duration,
          size,
          protocol: res.nextHopProtocol || 'unknown',
          cached: res.transferSize === 0,
          timestamp: Date.now(),
        })
      }
    })

    observer.observe({ type: 'resource', buffered: true })
  } catch {
    // 浏览器不支持，静默跳过
  }
}

/** 归一化资源 URL：去掉 query 和 hash，保留路径 */
function normalizeResourceUrl(url: string): string {
  try {
    const parsed = new URL(url)
    return `${parsed.hostname}${parsed.pathname}`
  } catch {
    const withoutQuery = url.split('?')[0] ?? url
    return withoutQuery.split('#')[0] ?? withoutQuery
  }
}
